import { API_URL } from '@moniebook-web/types';
import {
    Axios,
    SHARED_QUERY_KEY,
    useInvalidateCache,
} from '@moniebook-web/utils';
import { useMutation } from '@tanstack/react-query';

async function dismissBanner(id: string) {
    const url = `${API_URL.BUSINESS.BANNER}/${id}/complete`;
    const { data } = await Axios.patch(url);

    return data;
}

export const useDismissBannerApi = () => {
    const resetCache = useInvalidateCache();

    return useMutation({
        mutationFn: dismissBanner,
        onSuccess: () => {
            resetCache([SHARED_QUERY_KEY.GET_GLOBAL_BANNER_INFO]);
        },
    });
};
